var toString = Object.prototype.toString;

module.exports = function (type, obj) {
  return toString.call(obj) === "[object ".concat(type.charAt(0).toUpperCase() + type.slice(1), "]");
};